(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2532],{

/***/ 15800:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/[slug]",
      function () {
        return __webpack_require__(63605);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
;// CONCATENATED MODULE: ./src/components/BreadCrumbs/BreadCrumbs.tsx








var BreadCrumbs_Link = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
function BreadCrumbs(props) {
    var breadcrumbs = props.breadcrumbs;
    var theme = (0,useTheme/* default */.Z)();
    var crumbRefs = react.useRef([]);
    var t = (0,useTranslation/* useTranslation */.$)([
        "common"
    ]).t;
    // Todo: Fix crumbRefs.current typescript problem.
    // @ts-ignore
    crumbRefs.current = breadcrumbs.map(function(crumb, index) {
        var _index;
        // @ts-ignore
        return (_index = crumbRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    if (!(props === null || props === void 0 ? void 0 : props.hidden)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs/* default */.Z, {
        "aria-label": "breadcrumb",
        sx: {
            margin: theme.spacing(2, 0)
        },
        children: breadcrumbs.map(function(crumb, index) {
            return breadcrumbs[breadcrumbs.length - 1] ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "text.primary",
                href: crumb.path,
                "aria-current": "page",
                variant: "body2",
                children: crumb.name === "Home" ? t("home", "Home") : crumb.name
            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "inherit",
                href: crumb.path,
                variant: "body2",
                children: crumb.name
            }, index);
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/index.ts



/***/ }),

/***/ 62430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ImageLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/ImageLoaderWrapper.tsx





/**
 * Calculates the proper height of an image with a custom width, preserving the original aspect ratio.
 *
 * @param originalHeight
 * @param originalWidth
 * @param newWidth
 */ function determineNewHeight(originalHeight, originalWidth, newWidth) {
    return Math.ceil(originalHeight / originalWidth * newWidth);
}
var ImageLoaderWrapper = function(props) {
    var height = props.height, width = props.width, grayscale = props.grayscale, format = props.format, layout = props.layout, alt = props.alt, _rszHeight = props.rszHeight, rszHeight = _rszHeight === void 0 ? true : _rszHeight, other = (0,_object_without_properties/* default */.Z)(props, [
        "height",
        "width",
        "grayscale",
        "format",
        "layout",
        "alt",
        "rszHeight"
    ]);
    var loader = function(loaderProps) {
        var q = loaderProps.quality, w = loaderProps.width, src = loaderProps.src;
        // if (/^https?:\/\//.test(src)) return src;
        // Can find the query properties here;
        // https://gitlab.azerdev.com/huz.byorbit/huz-media/-/blob/master/src/asset/index.js
        // Todo: HUZ2ERA-1106 - Seems our media server won't allow us to resize webp assets by ratio operation.
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&ar[r]=${width}x${height}&ar[w]=${w}`;
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&rsz[w]=${w}`;
        var url = "".concat(src.replace(/\/+$/, ""), "/?fmt=").concat(format || "webp", "&rsz[w]=").concat(w);
        if (rszHeight) {
            url += "&rsz[h]=".concat(determineNewHeight(height, width, w));
        }
        if (grayscale) url += "&gsc=".concat(grayscale);
        return url;
    };
    // Make sure we don't pass width and height when layout is set to 'fill'. Refer to Next/image docs.
    return layout === "fill" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        layout: layout,
        loader: loader
    })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        width: width,
        height: height,
        loader: loader
    }));
};

;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/index.ts



/***/ }),

/***/ 80830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ PaperColorElevation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
;// CONCATENATED MODULE: ./src/components/PaperColorElevation/PaperColorElevation.tsx







var PaperStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z, {
    target: "e4eo54y0"
})(function(param) {
    var theme = param.theme, elevation = param.elevation;
    return {
        boxShadow: theme.shadows[elevation || 1],
        backgroundColor: theme.palette.mode === "dark" ? (0,colorManipulator/* lighten */.$n)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0) : (0,colorManipulator/* darken */._j)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0)
    };
});
var PaperColorElevation = function(props) {
    var children = props.children, other = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaperStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/PaperColorElevation/index.ts



/***/ }),

/***/ 96410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ SubscriptionModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47727);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59791);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5616);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18633);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _contexts_AuthenticationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43477);










var ModalContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "e16465q70"
})(function() {
    return {
        background: "linear-gradient(0deg, #000000 0%, #191040b5 30%, rgba(0,212,255,0) 100%)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        cursor: "default",
        button: {
            transition: "0.01s",
            "&:hover": {
                background: "#3352fe",
                outline: "1px solid white"
            }
        }
    };
});
var HeaderContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q71"
})(function() {
    return {
        fontSize: "54px",
        fontWeight: "600",
        textTransform: "uppercase",
        p: {
            color: "white"
        },
        "@media screen and (max-width: 800px)": {
            fontSize: "24px"
        }
    };
});
var HeaderSubText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q72"
})(function() {
    return {
        color: "orange",
        marginBottom: "16px"
    };
});
var LoginButtonContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q73"
})(function() {
    return {
        position: "absolute",
        right: "16px",
        top: "16px",
        display: "block",
        "@media screen and (max-width: 800px)": {
            display: "none"
        }
    };
});
var PrimaryButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e16465q74"
})(function() {
    return {
        background: "#3352fe",
        padding: "8px 24px",
        color: "white",
        fontSize: "18px"
    };
});
var StartButtonContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e16465q75"
})(function() {
    return {
        background: "#3352fe",
        padding: "12px 32px",
        color: "white",
        fontSize: "18px",
        "@media screen and (max-width: 800px)": {
            maxWidth: "calc(100% - 24px)"
        }
    };
});
var BoxContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "e16465q76"
})(function() {
    return {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        paddingBottom: 3,
        width: "80vw",
        height: "80vh",
        outline: "none",
        paddingTop: 2,
        background: 'url("/images/settings-bg.png")',
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        borderBottom: "2px solid #3352fe",
        "@media screen and (max-width: 800px)": {
            backgroundSize: "auto 100%"
        }
    };
});
var ListContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q77"
})(function() {
    return {};
});
var ListItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q78"
})(function() {
    return {
        display: "flex",
        alignItems: "center",
        margin: "8px 0",
        color: "white",
        svg: {
            marginRight: "8px",
            height: "32px",
            width: "32px"
        }
    };
});
var TextUnderline = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e16465q79"
})(function() {
    return {
        cursor: "pointer",
        color: "white",
        textDecoration: "underline",
        "&:hover": {
            color: "#fafafa",
            textDecorationThickness: "2px"
        }
    };
});
var SubscriptionModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(true), 2), openState = ref[0], setOpenState = ref[1];
    var userToken = (0,_contexts_AuthenticationContext__WEBPACK_IMPORTED_MODULE_3__/* .useAuthenticationContext */ .l)().userToken;
    var handleClose = function() {
        setOpenState(false);
    };
    var router = (0,next_translate_routes__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var redirectAzcConnect = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                router.push("/subscription/auth");
                return [
                    2
                ];
            });
        });
        return function redirectAzcConnect() {
            return _ref.apply(this, arguments);
        };
    }();
    return openState ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ModalContainer, {
        open: !userToken && openState,
        onClose: handleClose,
        "aria-labelledby": "modal-modal-title",
        "aria-describedby": "modal-modal-description",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(BoxContainer, {
            sx: {
                bgcolor: "background.paper",
                boxShadow: 24,
                px: 4
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(LoginButtonContainer, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(PrimaryButton, {
                        color: "primary",
                        onClick: redirectAzcConnect,
                        children: "Login"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(HeaderContainer, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("p", {
                            style: {
                                marginTop: "24px",
                                marginBottom: 0
                            },
                            children: " Play all of huz."
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("p", {
                            style: {
                                margin: "8px 0"
                            },
                            children: "Try us, cancel at anytime "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("div", {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(HeaderSubText, {
                        children: "Enjoy and play unlimited online games for only $4.99/month"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ListContainer, {
                    children: [
                        "No Advirtesement",
                        "Unlimited gameplays",
                        "Cancel at anytime",
                        "Play on any device",
                        "Children Account", 
                    ].map(function(i) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(ListItem, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    style: {
                                        color: "green"
                                    }
                                }),
                                i
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                    style: {
                        position: "absolute",
                        bottom: "32px"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                            style: {
                                marginBottom: "12px",
                                color: "white"
                            },
                            children: [
                                "HUZ is a subscription service. To see Terms and Conditions",
                                " ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TextUnderline, {
                                    href: "https://static.gamedistribution.com/terms/both.html",
                                    children: "click here."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(StartButtonContainer, {
                            color: "primary",
                            onClick: redirectAzcConnect,
                            children: "Start Your Game Adventure"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                            style: {
                                marginTop: "12px",
                                color: "white"
                            },
                            children: [
                                "You can cancel anytime, ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TextUnderline, {
                                    onClick: handleClose,
                                    children: "or try later"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .Fragment */ .HY, {});
};


/***/ }),

/***/ 61546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ Title; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/Title/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_title_color",
                label: "General text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_title_color",
                label: "Title text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_link_hover_color",
                label: "Link text hover color",
                type: "color",
                default: theme.palette.action.hover
            },
            {
                name: "theme_component_title_link_active_color",
                label: "Link text active color",
                type: "color",
                default: theme.palette.action.active
            },
            // {
            //   name: 'theme_component_title_padding',
            //   label: 'Padding',
            //   type: 'text',
            //   default: theme.spacing(1, 2),
            //   helperText: 'Define as top right left bottom; e.g.: 2px 10px 5px 10px',
            // },
            {
                name: "theme_component_title_lg_padding",
                label: "Padding for large screens",
                type: "text",
                default: theme.spacing(1, 2),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            // {
            //   name: 'theme_component_title_justify_content',
            //   label: 'Justify content',
            //   type: 'select',
            //   default: 'space-between',
            //   options: ['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'],
            // },
            // {
            //   name: 'theme_component_title_align_items',
            //   label: 'Align items',
            //   type: 'select',
            //   default: 'center',
            //   options: ['flex-start', 'flex-end', 'center', 'baseline', 'stretch'],
            // },
            {
                name: "theme_component_title_border_bottom_width",
                label: "Border bottom width",
                type: "number",
                endAdornment: "px",
                default: 1
            },
            {
                name: "theme_component_title_border_bottom_color",
                label: "Border bottom color",
                type: "color",
                default: theme.palette.divider
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
;// CONCATENATED MODULE: ./src/components/Title/Title.tsx










var Title_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Container/* default */.Z, {
    target: "e15gjue10"
})(function(param) {
    var theme = param.theme;
    return {
        borderBottomWidth: theme.theme_component_title_border_bottom_width ? "".concat(theme.theme_component_title_border_bottom_width, "px") : 1,
        borderBottomStyle: "solid",
        borderBottomColor: theme.theme_component_title_border_bottom_color || theme.palette.divider,
        color: theme.theme_component_title_color || theme.palette.text.primary,
        paddingTop: theme.spacing(1.25),
        paddingBottom: theme.spacing(1.25),
        textTransform: "capitalize"
    };
});
var TypographyStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Title_Typography, {
    target: "e15gjue11"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        color: theme.theme_component_title_title_color || "inherit",
        "& > a": {
            color: theme.theme_component_title_title_color || theme.palette.text.primary,
            "&:hover": {
                color: theme.theme_component_title_link_hover_color || theme.palette.action.hover
            },
            "&:active": {
                color: theme.theme_component_title_link_active_color || theme.palette.action.active
            }
        }
    };
});
var Title = function(props) {
    var disableGutters = props.disableGutters, children = props.children, className = props.className, style = props.style, other = (0,_object_without_properties/* default */.Z)(props, [
        "disableGutters",
        "children",
        "className",
        "style"
    ]);
    var titleRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        maxWidth: false,
        disableGutters: disableGutters,
        className: className,
        style: style
    }, useEditorHandlers("Title")), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypographyStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: titleRef
        }, other), {
            children: children
        }))
    }));
};

;// CONCATENATED MODULE: ./src/components/Title/index.ts



/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ }),

/***/ 63605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ DynamicPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/index.js + 115 modules
var react_markdown_lib = __webpack_require__(34585);
// EXTERNAL MODULE: ./node_modules/remark-gfm/lib/index.js + 54 modules
var remark_gfm_lib = __webpack_require__(55186);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/containers/GameA/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_game_description_background_color",
                label: "Description Section Background Color",
                type: "color",
                default: theme.palette.secondary.dark,
                helperText: "Description area background Color"
            },
            {
                name: "theme_component_game_description_font_color",
                label: "Description Section Font Color",
                type: "color",
                default: theme.palette.secondary.light,
                helperText: "Description area background Color"
            }, 
        ],
        configuration: [
            {
                name: "component_game_player_header_style",
                label: "Header layout style",
                type: "select",
                default: "full",
                options: [
                    "hidden",
                    "minimal",
                    "full"
                ]
            },
            {
                name: "component_walk_through_publisher_id",
                label: "Tubia publisher identifier",
                type: "text",
                helperText: "The publisher identifier can be requested through your account manager."
            },
            {
                name: "component_share_enable_web_api",
                label: "Enable share button",
                type: "checkbox",
                default: false,
                helperText: "Will open the client device its default sharing options (only on mobile devices)."
            },
            {
                name: "component_share_enable_embed_clipboard",
                label: "Enable embed button",
                type: "checkbox",
                default: false,
                helperText: "Will add the game URL to the client its clipboard."
            },
            {
                name: "component_game_mobile_play_button_background_color",
                label: "Mobile Play Button Background Color",
                type: "text",
                helperText: "On Mobile Game Page is changing for navigator devices"
            },
            {
                name: "component_game_mobile_play_button_color",
                label: "Mobile Play Button Font Color",
                type: "text",
                helperText: "On Mobile Game Page is changing for navigator devices"
            }, 
        ]
    });
};

// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 5 modules
var AppContext = __webpack_require__(24911);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./src/utils/ads-request.ts
var ads_request = __webpack_require__(18505);
;// CONCATENATED MODULE: ./src/utils/truncate-string.ts
var truncateString = function(str, n, useWordBoundary) {
    if (str.length <= n) {
        return str;
    }
    var subString = str.substr(0, n - 1); // the original check
    return "".concat(useWordBoundary ? subString.substr(0, subString.lastIndexOf(" ")) : subString, "...");
};
/* harmony default export */ var truncate_string = ({
    truncateString: truncateString
});

// EXTERNAL MODULE: ./src/components/ImageLoaderWrapper/index.ts + 1 modules
var ImageLoaderWrapper = __webpack_require__(62430);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
// EXTERNAL MODULE: ./src/components/Title/index.ts + 2 modules
var Title = __webpack_require__(61546);
// EXTERNAL MODULE: ./src/components/BreadCrumbs/index.ts + 1 modules
var BreadCrumbs = __webpack_require__(87082);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Share.js
var Share = __webpack_require__(11359);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Code.js
var Code = __webpack_require__(96214);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDownward.js
var ArrowDownward = __webpack_require__(26613);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowUpward.js
var ArrowUpward = __webpack_require__(54364);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(95753);
;// CONCATENATED MODULE: ./src/containers/GameA/GameA.tsx
































//import UAgent from '../../utils/u-agent';

var GameFrame = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7533), __webpack_require__.e(4881), __webpack_require__.e(1813)]).then(__webpack_require__.bind(__webpack_require__, 71813)).then(function(mod) {
        return mod.GameFrame;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71813)
            ];
        }
    },
    ssr: false
});
var AdvertisementSlot = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9918).then(__webpack_require__.bind(__webpack_require__, 29918)).then(function(mod) {
        return mod.AdvertisementSlot;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29918)
            ];
        }
    },
    ssr: false
});
var CollectionSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7839).then(__webpack_require__.bind(__webpack_require__, 67839)).then(function(mod) {
        return mod.CollectionSection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67839)
            ];
        }
    },
    ssr: false
});
var CarouselList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7397), __webpack_require__.e(3091), __webpack_require__.e(766)]).then(__webpack_require__.bind(__webpack_require__, 24905)).then(function(mod) {
        return mod.CarouselList;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24905)
            ];
        }
    },
    ssr: false
});
var GameA_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var GameDesktop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "erkbij0"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        width: "100%"
    };
});
var GameMobile = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "erkbij1"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        position: "relative",
        padding: theme.spacing(2, 2),
        margin: theme.spacing(0)
    };
});
var GameHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erkbij2"
})(function(param) {
    var theme = param.theme, headerLayout = param.headerLayout;
    var styles = {};
    if (headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL) {
        styles = (0,_define_property/* default */.Z)({}, theme.breakpoints.up("sm"), {
            height: "90px"
        });
    }
    return (0,_object_spread/* default */.Z)({
        display: "flex",
        alignItems: "center",
        width: "100%",
        marginBottom: 0,
        padding: theme.spacing(1.5)
    }, styles);
});
var GameHeaderMeta = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erkbij3"
})(function(param) {
    var theme = param.theme;
    return {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        padding: theme.spacing(0, 0, 0, 2),
        // overflow: 'hidden',
        "& > h1": (0,_define_property/* default */.Z)({}, theme.breakpoints.up("sm"), {
            textAlign: theme.direction === "rtl" ? "right" : "left",
            margin: theme.spacing(0)
        }),
        "& > span": (0,_define_property/* default */.Z)({
            display: "none"
        }, theme.breakpoints.up("sm"), {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: (0,colorManipulator/* darken */._j)(theme.palette.text.primary, 0.05),
            minWidth: "0"
        })
    };
});
var GameHeaderImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erkbij4"
})(function(param) {
    var theme = param.theme, headerLayout = param.headerLayout;
    var styles = {};
    if (headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL) {
        styles = {
            width: 65,
            height: 65
        };
    } else {
        styles = (0,_define_property/* default */.Z)({
            display: "none"
        }, theme.breakpoints.up("sm"), {
            display: "block",
            float: "left",
            width: 30,
            height: 30
        });
    }
    return styles;
});
var AdvertisementSlotStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot, {
    target: "erkbij5"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        width: "fit-content",
        margin: "auto"
    };
});
var AdvertisementSlotContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "erkbij6"
})(function(param) {
    var theme = param.theme;
    return {
        padding: 0,
        boxShadow: theme.shadows[0]
    };
});
var Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "erkbij7"
})(function(param) {
    var theme = param.theme;
    return {
        position: "relative"
    };
});
var SectionDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(GameA_Typography, {
    target: "erkbij8"
})(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(2),
        color: theme.theme_component_game_description_font_color || theme.palette.secondary.light,
        backgroundColor: theme.theme_component_game_description_background_color || theme.palette.secondary.dark
    };
});
var DescriptionTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Title/* Title */.D, {
    target: "erkbij9"
})(function(param) {
    var theme = param.theme;
    return {
        color: theme.theme_component_game_description_font_color || theme.palette.secondary.light,
        backgroundColor: theme.theme_component_game_description_background_color || theme.palette.secondary.dark,
        h1: {
            color: theme.theme_component_game_description_font_color || theme.palette.secondary.light,
            backgroundColor: theme.theme_component_game_description_background_color || theme.palette.secondary.dark
        }
    };
});
var GameA = function(props) {
    var ref, ref1;
    var game = props.game, global = props.global, pageContext = props.pageContext;
    var t = (0,useTranslation/* useTranslation */.$)("game_a").t;
    var theme = (0,useTheme/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react_intersection_observer/* useInView */.YD)(), ref3 = ref2.ref, inView = ref2.inView;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref4 = appContext.useConfig(), assetUrl = ref4.assetUrl, componentOptions = ref4.componentOptions;
    // @ts-ignore
    //const [uAgent] = React.useState(new UAgent({ debug: false }));
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(dist_lib/* isMobile */.tq), 2), gameRunning = ref5[0], setGameRunning = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), description = ref6[0], setDescription = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), domLoaded = ref7[0], setDomLoaded = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), descriptionIsTruncated = ref8[0], setDescriptionIsTruncated = ref8[1];
    var descriptionTruncateLength = 350;
    var md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    var swiperOptions = {
        breakpoints: {
            900: {
                slidesPerView: 4,
                slidesPerGroup: 4
            },
            600: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            0: {
                slidesPerView: 2,
                slidesPerGroup: 2
            }
        }
    };
    var publisherId = componentOptions.component_walk_through_publisher_id;
    var enableShare = typeof componentOptions.component_share_enable_web_api === "boolean" ? componentOptions.component_share_enable_web_api : true;
    var enableClipBoard = typeof componentOptions.component_share_enable_embed_clipboard === "boolean" ? componentOptions.component_share_enable_embed_clipboard : true;
    var headerLayout = componentOptions.component_game_player_header_style || types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL;
    var layoutAreas = componentOptions.component_game_player_areas || [
        types_enum/* GameLayoutAreaEnum.GAME */.o_.GAME,
        types_enum/* GameLayoutAreaEnum.COLLECTION_POPULAR */.o_.COLLECTION_POPULAR,
        types_enum/* GameLayoutAreaEnum.ADVERTISEMENT */.o_.ADVERTISEMENT,
        types_enum/* GameLayoutAreaEnum.CATEGORY */.o_.CATEGORY,
        types_enum/* GameLayoutAreaEnum.DESCRIPTION */.o_.DESCRIPTION,
        types_enum/* GameLayoutAreaEnum.COLLECTION_LATEST */.o_.COLLECTION_LATEST, 
    ];
    var cardType = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_carousel_card_type;
    var startPlayButtonBackgroundColor = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_mobile_play_button_background_color;
    var startPlayButtonColor = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_mobile_play_button_color;
    var banners = [
        "idhb-middle-728"
    ];
    var titleRef = react.useRef(null);
    var subtitleRef = react.useRef(null);
    var descriptionRef = react.useRef(null);
    var buttonMobilePlayRef = react.useRef(null);
    var buttonMobileShareRef = react.useRef(null);
    var buttonMobileClipBoardRef = react.useRef(null);
    var buttonMoreRef = react.useRef(null);
    var toggleTruncateDescription = function() {
        setDescriptionIsTruncated(!descriptionIsTruncated);
        if (descriptionIsTruncated) {
            setDescription((game === null || game === void 0 ? void 0 : game.description) || "");
        } else {
            setDescription(truncateString((game === null || game === void 0 ? void 0 : game.description) || "", descriptionTruncateLength, true));
        }
    };
    var handleToggleGame = function() {
        setGameRunning(function(running) {
            return !running;
        });
    };
    var openSnackbar = function(value) {
        if (value === "share") {
            if (navigator.share) {
                var ref;
                navigator.share({
                    url: (ref = window.location) === null || ref === void 0 ? void 0 : ref.href
                });
            } else {
                console.error("Browser doesn't support Web Share API");
            }
        } else {
            navigator.clipboard.writeText(game.src || "");
        // Todo: HUZ2ERA-1108 - Enable snackbar
        // if (snackbar) snackbar({ message: 'Copied to clipboard', variant: 'success' });
        }
    };
    react.useEffect(function() {
        (0,ads_request/* adsRequest */.S)(banners);
        setDomLoaded(true);
    }, []);
    react.useEffect(function() {
        if (dist_lib/* isMobile */.tq && !gameRunning && router.query.slug) {
            setGameRunning(true);
        }
    }, [
        router.query.slug
    ]);
    react.useEffect(function() {
        var events = router.events;
        var handleRouteChange = function() {
            (0,ads_request/* adsRequest */.S)(banners);
        };
        events.on("routeChangeComplete", handleRouteChange);
        events.on("hashChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
            events.off("hashChangeComplete", handleRouteChange);
        };
    }, [
        router
    ]);
    react.useEffect(function() {
        setDescription(truncateString(game.description || "", descriptionTruncateLength, true));
    }, [
        game
    ]);
    var checkSectionVisibility = function(sectionName) {
        var grids = layoutAreas.map(function(area) {
            return '"'.concat(area, '"');
        }).join("\r\n");
        return grids.includes(sectionName);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        maxWidth: "md",
        disableGutters: true,
        ref: ref3
    }, useEditorHandlers("Game Page")), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                sx: {
                    gridArea: "breadcrumbs"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                    maxWidth: false,
                    disableGutters: md,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
                        breadcrumbs: pageContext.breadcrumbs
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                sx: {
                    display: "grid",
                    gridTemplateRows: "auto",
                    gridRowGap: "32px",
                    gridTemplateAreas: layoutAreas.map(function(area) {
                        return '"'.concat(area, '"');
                    }).join("\r\n")
                },
                children: [
                    domLoaded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.GAME */.o_.GAME,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_lib/* BrowserView */.I3, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                                    maxWidth: false,
                                    disableGutters: md,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameDesktop, {
                                        elevation: 1,
                                        children: [
                                            headerLayout !== types_enum/* GameHeaderLayoutEnum.HIDDEN */.k.HIDDEN && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameHeader, {
                                                headerLayout: headerLayout,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameHeaderImage, {
                                                        headerLayout: headerLayout,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLoaderWrapper/* ImageLoaderWrapper */.T, {
                                                            src: "".concat(assetUrl).concat(game.images.cover1x1 || game.images.cover, "/"),
                                                            width: headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL ? 64 : 32,
                                                            height: headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL ? 64 : 32,
                                                            alt: "".concat(game.name),
                                                            priority: true,
                                                            layout: "responsive"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameHeaderMeta, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameA_Typography, {
                                                                ref: titleRef,
                                                                variant: "h1",
                                                                component: "h1",
                                                                children: game.name
                                                            }),
                                                            headerLayout === types_enum/* GameHeaderLayoutEnum.FULL */.k.FULL && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameA_Typography, {
                                                                ref: subtitleRef,
                                                                variant: "subtitle1",
                                                                component: "span",
                                                                children: game.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                                sx: {
                                                    aspectRatio: "16/9",
                                                    backgroundColor: theme.palette.grey["900"]
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameFrame, {
                                                    game: game,
                                                    start: true
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_lib/* MobileView */.$, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
                                    maxWidth: false,
                                    disableGutters: md,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameFrame, {
                                            game: game,
                                            start: gameRunning,
                                            onStop: handleToggleGame,
                                            enableOrientationLock: true,
                                            enableDraggableMenu: true,
                                            enableResponsive: true
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameMobile, {
                                            elevation: 1,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "row"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                                            sx: {
                                                                display: "flex"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLoaderWrapper/* ImageLoaderWrapper */.T, {
                                                                src: "".concat(assetUrl).concat(game.images.cover1x1 || game.images.cover, "/"),
                                                                width: 100,
                                                                height: 100,
                                                                alt: "".concat(game.name),
                                                                priority: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GameHeaderMeta, {
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameA_Typography, {
                                                                    ref: titleRef,
                                                                    variant: "h1",
                                                                    component: "h1",
                                                                    children: game.name
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                                                    ref: buttonMobilePlayRef,
                                                                    onClick: handleToggleGame,
                                                                    variant: "contained",
                                                                    sx: {
                                                                        marginTop: "auto",
                                                                        background: startPlayButtonBackgroundColor,
                                                                        color: startPlayButtonColor
                                                                    },
                                                                    children: t("button.continue_playing", "Start playing")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                (enableShare || enableClipBoard) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    style: {
                                                        padding: theme.spacing(2, 0, 0)
                                                    },
                                                    children: [
                                                        enableShare && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                                            ref: buttonMobileShareRef,
                                                            variant: "contained",
                                                            size: "small",
                                                            color: "secondary",
                                                            onClick: function() {
                                                                return openSnackbar("share");
                                                            },
                                                            style: {
                                                                marginRight: theme.spacing(1),
                                                                backgroundColor: theme.palette.background.paper,
                                                                color: theme.palette.text.primary
                                                            },
                                                            startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Share/* default */.Z, {}),
                                                            children: t("button.share", "Share")
                                                        }),
                                                        enableClipBoard && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                                            ref: buttonMobileClipBoardRef,
                                                            variant: "contained",
                                                            size: "small",
                                                            color: "secondary",
                                                            onClick: function() {
                                                                return openSnackbar("embed");
                                                            },
                                                            style: {
                                                                marginRight: theme.spacing(1),
                                                                backgroundColor: theme.palette.background.paper,
                                                                color: theme.palette.text.primary
                                                            },
                                                            startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Code/* default */.Z, {}),
                                                            children: t("button.embed", "Copy link")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !componentOptions.component_ads_disabled && !componentOptions.component_game_ads_middle_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.ADVERTISEMENT */.o_.ADVERTISEMENT,
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotContainer, {
                            elevation: 0,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
                                slotIdentifier: "idhb-middle-728",
                                variant: md ? "728x90" : "320x50",
                                elevation: 1
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.DESCRIPTION */.o_.DESCRIPTION,
                            minWidth: 0
                        },
                        children: inView && checkSectionVisibility(types_enum/* GameLayoutAreaEnum.DESCRIPTION */.o_.DESCRIPTION) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                            maxWidth: false,
                            disableGutters: md,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
                                elevation: 1,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionTitle, {
                                        variant: headerLayout === "hidden" ? "h1" : "h2",
                                        component: headerLayout === "hidden" ? "h1" : "span",
                                        children: game.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionDescription, {
                                        ref: descriptionRef,
                                        variant: "body1",
                                        paragraph: true,
                                        gutterBottom: true,
                                        children: [
                                            description,
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                style: {
                                                    display: descriptionIsTruncated ? "none" : "block"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_markdown_lib/* Markdown */.U, {
                                                    remarkPlugins: [
                                                        remark_gfm_lib/* default */.Z
                                                    ],
                                                    children: pageContext === null || pageContext === void 0 ? void 0 : pageContext.seoContent
                                                })
                                            })
                                        ]
                                    }),
                                    game.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                        ref: buttonMoreRef,
                                        variant: "contained",
                                        onClick: toggleTruncateDescription,
                                        "aria-label": t("more_link", "More"),
                                        sx: {
                                            position: "absolute",
                                            bottom: 0,
                                            left: "50%",
                                            minWidth: 0,
                                            width: theme.spacing(5),
                                            height: theme.spacing(5),
                                            margin: "auto",
                                            borderRadius: "100%",
                                            transform: "translate(-50%, 50%)"
                                        },
                                        children: !descriptionIsTruncated ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUpward/* default */.Z, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownward/* default */.Z, {})
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.CATEGORY */.o_.CATEGORY,
                            minWidth: 0
                        },
                        children: ((ref = game === null || game === void 0 ? void 0 : game.categories[0]) === null || ref === void 0 ? void 0 : ref.slug) && inView && checkSectionVisibility(types_enum/* GameLayoutAreaEnum.CATEGORY */.o_.CATEGORY) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h3",
                                    variant: "h3",
                                    children: t("category", (ref1 = game === null || game === void 0 ? void 0 : game.categories[0]) === null || ref1 === void 0 ? void 0 : ref1.slug)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, (0,_object_spread/* default */.Z)({
                                    padding: theme.spacing(2),
                                    items: global.category || [],
                                    cardOptions: {
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                        layout: "responsive",
                                        template: cardType
                                    }
                                }, swiperOptions))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.COLLECTION_LATEST */.o_.COLLECTION_LATEST,
                            minWidth: 0
                        },
                        children: inView && checkSectionVisibility(types_enum/* GameLayoutAreaEnum.COLLECTION_LATEST */.o_.COLLECTION_LATEST) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h3",
                                    variant: "h3",
                                    children: t("latest_header", "Latest")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, (0,_object_spread/* default */.Z)({
                                    padding: theme.spacing(2),
                                    items: global.latest || [],
                                    cardOptions: {
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                        layout: "responsive",
                                        template: cardType
                                    }
                                }, swiperOptions))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            gridArea: types_enum/* GameLayoutAreaEnum.COLLECTION_POPULAR */.o_.COLLECTION_POPULAR,
                            minWidth: 0
                        },
                        children: inView && checkSectionVisibility(types_enum/* GameLayoutAreaEnum.COLLECTION_POPULAR */.o_.COLLECTION_POPULAR) && Array.isArray(global.popular) && global.popular.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h3",
                                    variant: "h3",
                                    children: t("popular_header", "Popular")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, (0,_object_spread/* default */.Z)({
                                    padding: theme.spacing(2),
                                    items: global.popular || [],
                                    cardOptions: {
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                        layout: "responsive",
                                        template: cardType
                                    }
                                }, swiperOptions))
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/containers/GameA/index.ts


;// CONCATENATED MODULE: ./src/generated/game/index.tsx




function View(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GameA, (0,_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./src/layouts/BaseLayout/index.tsx + 5 modules
var BaseLayout = __webpack_require__(92176);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(4510);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/utils/localize-helpers.ts
var localize_helpers = __webpack_require__(98751);
// EXTERNAL MODULE: ./src/components/SubscriptionModal/index.tsx
var SubscriptionModal = __webpack_require__(96410);
;// CONCATENATED MODULE: ./src/pages/game/[slug].tsx









// import { GameA as View } from '../../containers/GameA';







var timeoutId;
var intervalId;
var __N_SSG = true;
function DynamicPage(props) {
    var ref, ref1;
    var game = props.game, title = props.title, pageContext = props.pageContext;
    var ref2 = (0,esm/* useTranslation */.$G)([
        "common",
        "game"
    ]), t = ref2.t, i18n = ref2.i18n;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref3 = appContext.useConfig(), name = ref3.name, url = ref3.url, assetAbsoluteUrl = ref3.assetAbsoluteUrl, appIconId = ref3.appIconId, componentOptions = ref3.componentOptions;
    var router = (0,next_router.useRouter)();
    var paths = (0,localize_helpers/* getLocalizedPaths */.mT)(router);
    var siteUrl = "".concat(url === null || url === void 0 ? void 0 : url.replace(/\/+$/, ""));
    var metaTitle = ((ref = game.meta) === null || ref === void 0 ? void 0 : ref.title) || title;
    var seoTitle = i18n.exists("game:title", {
        fallbackLng: pageContext.locale
    }) ? t("game:title", {
        title: metaTitle
    }) : t("common:title", {
        title: metaTitle
    });
    var metaDescription = ((ref1 = game.meta) === null || ref1 === void 0 ? void 0 : ref1.description) || game.description;
    var seoDescription = i18n.exists("game:description", {
        fallbackLng: pageContext.locale
    }) ? t("game:description", {
        title: metaTitle,
        description: metaDescription
    }) : t("common:description", {
        title: metaTitle,
        description: metaDescription
    });
    var seoContent;
    // Record a game play event - after every 30 seconds - for internal analytics.
    react.useEffect(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                timeoutId = window.setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var response;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    recordGamePlayEvent(game.id)
                                ];
                            case 1:
                                response = _state.sent();
                                if (response === null || response === void 0 ? void 0 : response.id) {
                                    intervalId = window.setInterval(function() {
                                        return recordGamePlayContinueEvent(response.id);
                                    }, 30000);
                                } else {
                                    if (intervalId) window.clearInterval(intervalId);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }), 30000);
                return [
                    2
                ];
            });
        })();
        return function() {
            if (timeoutId) window.clearTimeout(timeoutId);
            if (intervalId) window.clearInterval(intervalId);
        };
    }, [
        game.id
    ]);
    // Customized SEO
    var seo = appContext.useSeo().seo;
    // Homepage page
    if (seo === null || seo === void 0 ? void 0 : seo.games) {
        var gamesSeo = Object.keys(seo.games);
        // Current game matches in SEO
        if (gamesSeo.includes(game.gdGameId) && router.locale) {
            var currentGame = seo.games[game.gdGameId];
            // Current game matches the same language
            if (currentGame[router.locale]) {
                var ref4, ref5, ref6;
                // Current game matches the same language has title
                if ((ref4 = currentGame[router.locale]) === null || ref4 === void 0 ? void 0 : ref4.title) {
                    var ref7;
                    seoTitle = (ref7 = currentGame[router.locale]) === null || ref7 === void 0 ? void 0 : ref7.title;
                }
                // Current game matches the same language has description
                if ((ref5 = currentGame[router.locale]) === null || ref5 === void 0 ? void 0 : ref5.description) {
                    var ref8;
                    seoDescription = (ref8 = currentGame[router.locale]) === null || ref8 === void 0 ? void 0 : ref8.description;
                }
                // Current game already added seo description
                if ((ref6 = currentGame[router.locale]) === null || ref6 === void 0 ? void 0 : ref6.gameDescription) {
                    var ref9;
                    seoContent = (ref9 = currentGame[router.locale]) === null || ref9 === void 0 ? void 0 : ref9.gameDescription;
                }
            }
        }
    }
    var pageContextWithPaths = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContext), {
        paths: paths,
        seoContent: seoContent
    });
    var showSubscriptionModal = componentOptions.component_project_subscription_mode;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            showSubscriptionModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscriptionModal/* SubscriptionModal */.u, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                title: seoTitle,
                description: seoDescription,
                openGraph: {
                    images: [
                        {
                            url: "".concat(assetAbsoluteUrl).concat(game.images.cover1x1 || game.images.cover, "/?ar[r]=1x1&ar[w]=512&fmt=.png"),
                            width: 512,
                            height: 512,
                            alt: "".concat(seoTitle),
                            type: "image/png"
                        }, 
                    ]
                },
                twitter: {
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* ArticleJsonLd */.dX, {
                type: "NewsArticle",
                url: "".concat(siteUrl).concat(router.asPath),
                title: "".concat(seoTitle),
                images: Object.values(game.images).filter(function(image) {
                    return image !== null;
                }).map(function(image) {
                    return "".concat(assetAbsoluteUrl).concat(image, "/");
                }),
                datePublished: "".concat(game.publishedAt),
                authorName: "GameDistribution",
                publisherName: "".concat(name),
                publisherLogo: "".concat(assetAbsoluteUrl).concat(appIconId),
                description: "".concat(seoDescription)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: pageContextWithPaths.breadcrumbs.map(function(crumb, index) {
                    return {
                        position: index + 1,
                        name: crumb.name,
                        item: crumb.href
                    };
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                pageContext: pageContextWithPaths
            }))
        ]
    });
}
// Adding getLayout property. Allowing us to return a React component for the layout.
// This allows us to define the layout on a per-page basis. Since we're returning a function,
// we can have complex nested layouts if desired.
DynamicPage.getLayout = function getLayout(page) {
    var props = page.props;
    var pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseLayout/* BaseLayout */.I, {
        pageType: "game",
        pageContext: pageContext,
        children: page
    });
};
function recordGamePlayContinueEvent(id) {
    return _recordGamePlayContinueEvent.apply(this, arguments);
}
function _recordGamePlayContinueEvent() {
    _recordGamePlayContinueEvent = (0,_async_to_generator/* default */.Z)(function(id) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios_default().put("".concat("/cms/", "histories/plays/continue?").concat(lib_default().stringify({
                            game: id
                        })), {
                            addQueryPrefix: true
                        }, {
                            headers: {
                                Accept: "application/json",
                                "X-Project-Id": "ad78bc92-65f7-4bc2-aacf-8434527a7789" || 0
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    // console.log(JSON.stringify(data, null, 4));
                    // 👇️ "response status is: 200"
                    // console.log('response status is: ', status);
                    return [
                        2,
                        data
                    ];
                case 2:
                    error = _state.sent();
                    if (intervalId) window.clearInterval(intervalId);
                    if (axios_default().isAxiosError(error)) {
                        console.error(error.message);
                    } else {
                        console.error(error);
                    }
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _recordGamePlayContinueEvent.apply(this, arguments);
}
function recordGamePlayEvent(id) {
    return _recordGamePlayEvent.apply(this, arguments);
}
function _recordGamePlayEvent() {
    _recordGamePlayEvent = (0,_async_to_generator/* default */.Z)(function(id) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios_default().put("".concat("/cms/", "histories/plays/start?").concat(lib_default().stringify({
                            game: id
                        })), {
                            addQueryPrefix: true
                        }, {
                            headers: {
                                Accept: "application/json",
                                "X-Project-Id": "ad78bc92-65f7-4bc2-aacf-8434527a7789" || 0
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    // console.log(JSON.stringify(data, null, 4));
                    // 👇️ "response status is: 200"
                    // console.log('response status is: ', status);
                    return [
                        2,
                        data
                    ];
                case 2:
                    error = _state.sent();
                    if (timeoutId) window.clearInterval(timeoutId);
                    if (axios_default().isAxiosError(error)) {
                        console.error(error.message);
                    } else {
                        console.error(error);
                    }
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _recordGamePlayEvent.apply(this, arguments);
}


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1301,78,5675,8529,9791,8398,7097,8178,3500,9774,2888,179], function() { return __webpack_exec__(15800); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);